import script from "./TipsForSuccessPage.vue?vue&type=script&setup=true&lang=js"
export * from "./TipsForSuccessPage.vue?vue&type=script&setup=true&lang=js"

import "./TipsForSuccessPage.vue?vue&type=style&index=0&id=1d39093e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1d39093e"]])

export default __exports__